// extracted by mini-css-extract-plugin
export default {"row":"open-image-popup__row___rFFlr"};